



























































import { Actor } from '@/data/models/actor.model';
import { Headquarter } from '@/data/models/headquarter.model';
import { CrudService } from '@/data/services/crud.service';
import store, { State } from '@/store';
import { Component, Inject, Vue } from 'vue-property-decorator';
import AttorePersonalData from './AttorePersonalData.vue';
import VolontarioDetail from '../../volontari/VolontarioDetail.vue';
import AssociatoDetail from '../../associati/AssociatoDetail.vue';
import PazienteDetail from '../../pazienti/PazienteDetail.vue';
import DottoreDetail from '../../dottori/DottoreDetail.vue';
import { Volunteer } from '@/data/models/volunteer.model';
import { Associate } from '@/data/models/associate.model';
import { Doctor } from '@/data/models/doctor.model';

@Component({
	components: { AttorePersonalData, VolontarioDetail, AssociatoDetail, PazienteDetail, DottoreDetail },
})
export default class AttoreTabs extends Vue {
	
	@Inject('CrudService') actorCrudService!: CrudService<Actor>;

	actor: Actor;
	isOpen=true;
	state!: State;
	loading!: boolean;
	activeTab: number; 
	
	constructor() {
		super();
		this.state = store;
		this.actor = new Actor();
		this.activeTab = 0;
	}

	created() {
		const actorid = this.$route.params.actorid;
		if(actorid) {
			this.loadActor(+actorid);
		} else {
			this.actor = new Actor();
			this.actor.hqid = this.headquarter?.id;
		}

		const tab = +this.$route.query.tab;
		this.activeTab = tab | 0;
		
	}

	loadActor(actorid: number) {
		this.actorCrudService.getEntity(Actor, 'actor', actorid).then((actor) => {
			this.actor = actor;
		}).catch((error) => {
			this.$buefy.notification.open({
				message: error.msg,
				type: 'is-danger',
			});
		}).finally(() => this.loading = false);
	}

	saveVolunteer(event: Volunteer) {
		if(this.actor && !this.actor.volunteerid) {
			this.actor.volunteerid = event.id;
			this.saveActor();
		} else if(this.actor && !event.id) {
			this.actor.volunteerid = undefined;
			this.saveActor();
		}
	}

	saveAssociate(event: Associate) {
		if(this.actor && !this.actor.associateid) {
			this.actor.associateid = event.id;
			this.saveActor();
		} else if(this.actor && !event.id) {
			this.actor.associateid = undefined;
			this.saveActor();
		}
	}

	savePatient(event: Associate) {
		if(this.actor && !this.actor.patientid) {
			this.actor.patientid = event.id;
			this.saveActor();
		} else if(this.actor && !event.id) {
			this.actor.patientid = undefined;
			this.saveActor();
		}
	}

	saveDoctor(event: Doctor) {
		if(this.actor && !this.actor.doctorid) {
			this.actor.doctorid = event.id;
			this.saveActor();
		} else if(this.actor && !event.id) {
			this.actor.doctorid = undefined;
			this.saveActor();
		}
	}

	saveActor() {
		this.actorCrudService.saveEntity(Actor, 'actor', this.actor).then(result => {
			this.actor = result;
		});
	}

	onActorUpdate(actor: Actor) {
		if(!this.actor?.id) {
			this.$router.push(`/attori/${actor.id}/edit`);
		}
		this.actor = actor;
	}

	get headquarter(): Headquarter | undefined {
		return this.state.headquarter;
	}
	
}
